<template>
  <div class="list">
    <van-pull-refresh v-model="refreshing" @refresh="onLoad">
      <div style="min-height: 90vh">
        <ListItem v-for="item in showList" :key="item.id" :value="item" :type="listType"  :id="id" :itemType="type"/>
      </div>
    </van-pull-refresh>

  </div>
</template>

<script>
import ListItem from "./listItem";
import {
  Search,
  List,
  PullRefresh,
  Dialog,
  Toast
} from 'vant';

export default {
  components: {
    ListItem,
    [Search.name]: Search,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      searchKey: '',
      resultList: [],
      showList: [],
      refreshing: false,
      listType: 'mine',
      id: '',
      type: ''
    };
  },
  created() {
  const hash = window.location.hash
  const paramsStr = hash.split('?')[1]
  const params = new URLSearchParams(paramsStr)
  
  this.id = params.get('id')
  this.type = params.get('type')
  
  console.log('解析成功 id =', this.id)
  console.log('解析成功 type =', this.type)
},
  methods: {
    onSearch() {
      if (!this.resultList || this.resultList.length == 0) {
        return
      } else {
        this.showList = []
        this.resultList.forEach(re => {
          if (JSON.stringify(re).includes(this.searchKey))
            this.showList.push(re)
        })
      }
    },
    onSearchCancel() {
      this.showList = this.resultList
    },
    onLoad() {
      if (this.refreshing) {
        this.resultList = [];
        this.refreshing = false;
      }

      this.$axios.get('onlineSign/list?id=' + this.id + '&type=' + this.type).then(res => {
        this.showList = this.resultList = res
        if(this.showList.length == 0) {
          Toast('数据已提交')
        }
      }).catch(res => {
        Dialog.alert({
          title: '获取资产列表失败',
          message: res
        }).then(() => {
          this.loading = false;
        })
      })
    }
  },
  mounted() {
    this.onLoad()
    //       this.showList = this.resultList=  [{
    // "id": 123,
    // 		"asset_num": "123",
    // 		"serial": "",
    // 		"model": "",
    // 		"mobile": "",
    // 		"bu": "",
    // 		"user_name": "",
    // 		"phone": "",
    // 		"sign_time": "",
    // 		"n_name": "",
    // 		"sign_file": "",
    // 		"question": "",
    // 		"sign_notes": "",
    // 		"type": "pc"
    // 	}, {
    // "id": 456,
    // 		"asset_num": "123",
    // 		"serial": "",
    // 		"model": "",
    // 		"mobile": "",
    // 		"bu": "",
    // 		"user_name": "",
    // 		"phone": "",
    // 		"sign_time": "",
    // 		"n_name": "",
    // 		"sign_file": "",
    // 		"question": "",
    // 		"sign_notes": "",
    // 		"type": "phone"
    // 	}]

  }
};
</script>

<style lang="less">
.list {
  background-color: #F7F8FA;

  .card {}

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 40px;
  }

  &-submit {
    text-align: center;

    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }



  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>